
function SignInSideComponent() {
  return (
    <div className="flex justify-center w-[53%] bg-signinSideBg bg-repeat-y bg-cover h-[calc(100vh-110px)] rounded-[40px] bg-mint-100 mobile:hidden tablet:hidden">
      <img src="./assets/images/logo.svg" alt="" className="max-w-[500px]" />
    </div>
  );
}

export default SignInSideComponent;
